import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { Input } from "reactstrap";
import { fetchFormData } from "../../../helpers/backend_helper";

const CreatTicketMap = ({ SelectedLocation, initialLocation }) => {
  const mapRef = useRef(null);
  const mapContainerRef = useRef(null);
  const debounceTimeoutRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });

  L.Marker.prototype.options.icon = DefaultIcon;

  useEffect(() => {
    if (!mapRef.current && mapContainerRef.current) {
      const defaultLat = initialLocation?.lat || 19.9615;
      const defaultLng = initialLocation?.lng || 79.2961;
      const defaultZoom = initialLocation?.lat && initialLocation?.lng ? 14 : 9;

      mapRef.current = L.map(mapContainerRef.current).setView(
        [defaultLat, defaultLng],
        defaultZoom
      );

      L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
        maxZoom: 20,
        subdomains:['mt0','mt1','mt2','mt3']
}).addTo(mapRef.current);

      if (initialLocation?.lat && initialLocation?.lng) {
        const marker = L.marker([
          initialLocation.lat,
          initialLocation.lng,
        ]).addTo(mapRef.current);
        marker
          .bindPopup(
            `Latitude: ${initialLocation.lat}<br/>Longitude: ${initialLocation.lng}`
          )
          .openPopup();
      }

      mapRef.current.on("click", (e) => {
        const { lat, lng } = e.latlng;
        if (lat && lng) {
          mapRef.current.eachLayer((layer) => {
            if (layer instanceof L.Marker) mapRef.current.removeLayer(layer);
          });

          const marker = L.marker([lat, lng]).addTo(mapRef.current);
          marker
            .bindPopup(`Latitude: ${lat}<br/>Longitude: ${lng}`)
            .openPopup();
          mapRef.current.setView([lat, lng], 14);

          SelectedLocation({ lat, lng });
        }
      });
    }

    return () => {
      if (mapRef.current) {
        mapRef.current.remove();
        mapRef.current = null;
      }
    };
  }, [initialLocation]);

  const searchPlace = async (query) => {
    if (!query) return;

    const Payload = {
      act: "common",
      subact: "searchLLocation",
      info: {
        search: query,
      },
    };
    
    try {

      const response = await fetchFormData(Payload);

      if (response?.data?.Results && response?.data?.Results.length > 0) {
        setSearchResults(response?.data?.Results);
      } else {
        console.warn("No results found for the search query.");
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error searching place:", error);
    }
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchQuery(value);

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      searchPlace(`${value + ', chandrapur'}`);
    }, 500);
  };

  const handleSuggestionClick = (result) => {
    const { Geometry, Label } = result.Place || {};
    const latitude = Geometry?.Point[1];
    const longitude = Geometry?.Point[0];

    SelectedLocation({ lat: latitude, lng: longitude });

    if (mapRef.current) {
      mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          mapRef.current?.removeLayer(layer);
        }
      });

      const marker = L.marker([latitude, longitude]).addTo(mapRef.current);
      marker
        .bindPopup(
          `<b>${Label}</b><br/>Latitude: ${latitude}<br/>Longitude: ${longitude}`
        )
        .openPopup();

      mapRef.current.setView([latitude, longitude], 14);
    }

    setSearchResults([]);
    setSearchQuery(Label || "");
  };

  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginBottom: "10px", width: "100%", position: "relative" }}>
        <Input
          type="text"
          value={searchQuery}
          onChange={handleInputChange}
          placeholder="Search for a place in India..."
          style={{ padding: "8px" }}
        />
        {searchResults.length > 0 && (
          <ul
            style={{
              position: "absolute",
              top: "40px",
              left: "0",
              right: "0",
              background: "white",
              border: "1px solid #ccc",
              listStyle: "none",
              margin: 0,
              padding: "10px",
              zIndex: 100000,
            }}
          >
            {searchResults.map((result, index) => (
              <li
                key={index}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  borderBottom: "1px solid #eee",
                }}
                onClick={() => handleSuggestionClick(result)}
              >
                {result.Place?.Label}
              </li>
            ))}
          </ul>
        )}
      </div>

      <div
        id="map"
        ref={mapContainerRef}
        style={{ height: "500px", width: "100%" }}
      ></div>
    </div>
  );
};

export default CreatTicketMap;
